import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcCategory(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.999 19.25a.75.75 0 0 1 0 1.5h-13a.75.75 0 0 1 0-1.5zM19.25 9.5a4.75 4.75 0 1 0-9.5 0 4.75 4.75 0 0 0 9.5 0M5.999 12.75a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1 0-1.5zm0-6.5a.75.75 0 1 1 0 1.5h-4a.75.75 0 0 1 0-1.5zM20.75 9.5a6.22 6.22 0 0 1-1.273 3.776l3.194 3.194a.75.75 0 0 1-1.06 1.06l-3.176-3.176A6.25 6.25 0 1 1 20.75 9.5"
  }));
}
var IcCategory = createNolIcon(/*#__PURE__*/forwardRef(SvgIcCategory));

export { IcCategory as I };
